export default __webpack_public_path__ + "static/great-intrigue-banner-f0fb77e7a49c80a2f43e2b5b77ef5dce.png";